import API from "../api";

export const listLevels = (role, params = {}) => {
  const base =
    role === "ADMIN"
      ? "/admin/levels"
      : role === "MANAGER"
      ? "/manager/levels"
      : "/coach/levels";
  return API.get(base, { params });
};

export const getLevel = (role, id) => {
  const base =
    role === "ADMIN"
      ? "/admin/levels"
      : role === "MANAGER"
      ? "/manager/levels"
      : "/coach/levels";
  return API.get(`${base}/${id}`);
};

export const createLevel = (payload) => API.post("/admin/levels", payload); // admin path
export const createLevelManager = (payload) =>
  API.post("/manager/levels", payload);

export const updateLevel = (id, payload) =>
  API.put(`/admin/levels/${id}`, payload);
export const updateLevelManager = (id, payload) =>
  API.put(`/manager/levels/${id}`, payload);

export const archiveLevel = (id) => API.delete(`/admin/levels/${id}`);
